import cn from 'classnames';
import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';
import { useRef } from 'preact/hooks';

import { useEffect, useState } from 'preact/hooks';

const QuantitySelector = ({ item, setError }) => {
  const { updateLineItem } = useCartContext();
  const [quantity, setQuantity] = useState(item.quantity);
  const [updatingQuantity, setUpdatingQuantity] = useState(null);
  const typingTimer = useRef();

  useEffect(() => {
    if (item.quantity < updatingQuantity) {
      setError(item.quantity);
    }
    setQuantity(item.quantity);
    setUpdatingQuantity(null);
  }, [item]);

  const delayedQuantityUpdate = ({ target }) => {
    clearTimeout(typingTimer.current);
    if (target.value) {
      typingTimer.current = setTimeout(() => updateQuantity(target.value), 200);
      setQuantity(target.value);
    }
  };

  const updateQuantity = value => {
    setUpdatingQuantity(value);
    updateLineItem(item.id, value);
  };

  const Button = ({ children, label, onClick, disabled }) => (
    <button
      class={cn('h-5 w-5 border-none focus:outline-none focus:ring-1', {
        'cursor-default text-slate': disabled,
      })}
      type="button"
      aria-label={label}
      onClick={onClick}
      disabled={disabled || updatingQuantity !== null}
    >
      {children}
    </button>
  );

  return (
    <div class="inline-flex items-center">
      <Button
        label={getTranslation('general.form.decrement')}
        onClick={() => updateQuantity(quantity - 1)}
        disabled={quantity === 1}
      >
        <svg
          class="h-0.5 w-2.5 stroke-current md:w-4"
          viewBox="0 0 16 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6663 1H7.99967H1.33301"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </Button>

      <input
        class="hide-arrows md:type-form-label type-caption inline-block h-5 w-15 rounded-none border-none bg-transparent py-0 px-2 text-center"
        type="number"
        name="quantity"
        value={quantity}
        aria-label={getTranslation('general.form.quantity')}
        min="1"
        onInput={delayedQuantityUpdate}
      />

      <Button
        label={getTranslation('general.form.increment')}
        onClick={() => updateQuantity(quantity + 1)}
      >
        <svg
          class="h-2.5 w-2.5 stroke-current md:h-4 md:w-4"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.99967 1.3335V8.00016M7.99967 8.00016V14.6668M7.99967 8.00016H14.6663M7.99967 8.00016H1.33301"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </Button>
    </div>
  );
};

export default QuantitySelector;
